export default __webpack_public_path__ + "static/media/signature.bf4d9095.jpg";